import { LanePreferenceTable } from "@mcleod/dispatch/src/LanePreferenceTable";
import { LaneSendToContacts } from "@mcleod/dispatch/src/LaneSendToContacts";
import { TableComment } from "@mcleod/general/src/TableComment";
import { TableContact } from "@mcleod/general/src/TableContact";
import { CarrierOfferList } from "@mcleod/powerbroker/src/CarrierOfferList";
import { ManageCarrierCapacity } from "@mcleod/powerbroker/src/ManageCarrierCapacity";
import { CarrierActionList } from "@mcleod/powerbroker/src/crm/CarrierActionList";
import { DataSource, Layout, Panel, SaveButton, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierSalesDetail extends Layout {
    buttonSave: SaveButton;
    layoutCarrierActionList: CarrierActionList;
    layoutCarrierOfferList: CarrierOfferList;
    layoutLanePreferenceTable: LanePreferenceTable;
    layoutLaneSendToContacts: LaneSendToContacts;
    layoutManageCarrierCapacity: ManageCarrierCapacity;
    layoutTableComment: TableComment;
    layoutTableContact: TableContact;
    panelLanePreferenceDisplay: Panel;
    panelPnnComments: Panel;
    panelPnnOptions: Panel;
    sourceCarrier: DataSource;
    sourceCarrierAction: DataSource;
    sourceComments: DataSource;
    sourceContacts: DataSource;
    sourcePNNLane: DataSource;
    sourcePnnBuilderSendto: DataSource;
    switchActivePNNCarrier: Switch;
    switchLanePreferenceDisplay: Switch;
    tabActivities: Tab;
    tabComments: Tab;
    tabContacts: Tab;
    tabLanePreference: Tab;
    tabOffers: Tab;
    tabPnnOptions: Tab;
    tabTractors: Tab;
    tabsetCarrier: Tabset;
    tabsetPnnOptions: Tabset;
    textboxPnnCarriercomment1: Textbox;
    textboxPnnCarriercomment2: Textbox;
    textboxPnnCarrieremailProfileId: Textbox;
    textboxPnnCarrieroutputType: Textbox;
    textboxPnnCarrierreplyDetail: Textbox;
    textboxPnnCarrierreplyName: Textbox;
    textboxPnnCarrierreplyVia: Textbox;
    textboxPnnCarrierscheduleId: Textbox;
}
